import {
  EmployeePicker,
  FeatureWrap,
  Modal,
  RegularBusinessPicker,
  RegularInsurerPicker,
  SearchSelectInput,
} from "components";

import { useAppNavigate } from "_graphql/cache/auth";
import { useFormik } from "formik";
import { wrapClick } from "utils";

type Props = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

function FilterMenu({ open, setOpen }: Props) {
  const navigate = useAppNavigate();
  const form = useFormik({
    initialValues: {
      insurer: "",
      business: [],
      status: "",
    },
    onSubmit: (values) => {
      // Handle form submission
      navigate({
        search(old) {
          return {
            ...old,
            page: 1,
            insurer: values.insurer || undefined,
            business: values.business || undefined,
            orderStatus: values.status || undefined,
          };
        },
      });
      setOpen?.(false);
    },
    onReset: () => {
      navigate({
        search(old) {
          return {
            ...old,
            page: 1,
            insurer: undefined,
            business: undefined,
            orderStatus: undefined,
          };
        },
      });
      setOpen?.(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      // size="6xl"
      title="Filter Options"
      description="Select the criteria to filter the offers"
      renderActions={() => (
        <>
          <button
            type="button"
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={wrapClick(form.handleSubmit)}
          >
            Apply filter
          </button>
          <button
            type="button"
            className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 dark:border-gray-600 shadow-sm px-4 py-2 bg-white dark:bg-gray-900 text-base font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 hover:dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={wrapClick(form.resetForm)}
          >
            Reset Filters
          </button>
        </>
      )}
    >
      <div className="p-4">
        <h2 className="text-lg font-semibold"></h2>
        <p className="text-sm text-gray-500"></p>
        {/* Add filter options here */}
      </div>
      <div className="grid grid-cols-2 gap-6 ">
        <div>
          <RegularInsurerPicker
            id="insurer"
            label="Cedant"
            placeholder="Select Cedant"
            required={true}
            rawId
            {...form}
          />
        </div>
        <div>
          <RegularBusinessPicker
            id="business"
            label="Class of Business"
            placeholder="Select Class of Business"
            required={true}
            rawId
            multiple
            {...form}
          />
        </div>

        <div>
          <SearchSelectInput
            id="status"
            // labelHidden={true}
            options={[
              { label: { title: "Open" }, value: "OPEN" },
              { label: { title: "Pending" }, value: "PENDING" },
            ]}
            label={"Endorsement Status"}
            placeholder="Select Status"
            {...form}
          />
        </div>
      </div>
    </Modal>
  );
}

export default FilterMenu;
